import React, { Component, PropTypes } from 'react';
import styleable from 'react-styleable';
import defaultStyle from './modal-window.style';
import './common.scss';
import './modal-window.scss';

export class ModalWindow extends Component {

  render() {
    const { show, onClose, title, footer, children, css } = this.props;

    return(
      <div id="modal">
        <div className={show ? css.show : css.hide}>
          <div className={css.dialog}>
            <div className={css.content}>
              <div className={css.header}>
                <button type="button" className={css.closeButton} onClick={e => onClose(e)}>
                  <span aria-label="close">&times;</span>
                </button>
                <h4 className={css.title}>
                  {title}
                </h4>
              </div>
              <div className={css.body}>
                {children}
              </div>
              <div className={css.footer}>
                {footer}
              </div>
            </div>
          </div>
        </div>
        <div className={show ? css.backgroundShow : css.backgroundHide} />
      </div>
    );
  }
}

ModalWindow.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.any.isRequired,
  footer: PropTypes.element
};

export default styleable(defaultStyle) (ModalWindow);



// WEBPACK FOOTER //
// src/common/modal-window.js